
import * as Yup from "yup";


const coursevalidationSchema = Yup.object({
  name: Yup.string().required("Course name is required"),
  slug: Yup.string().required("Slug is required"),
  courseCode: Yup.string().required("Course code is required"),
  coursesChildren: Yup.array()
    .of(
      Yup.object({
        heading: Yup.string().required("Heading is required"),
        description: Yup.string(),
        textFields: Yup.array().of(
          Yup.object({
            heading: Yup.string().required("Heading is required"),
            description: Yup.string(),
            videoUrl: Yup.string(),
          }),
        ),
        childrenSubDetails: Yup.array().of(
          Yup.object({
            heading: Yup.string().required("Heading is required"),
            textFields: Yup.array().of(
              Yup.object({
                heading: Yup.string().required("Heading is required"),
                description: Yup.string(),
                videoUrl: Yup.string(),
              }),
            ),
          }),
        ),
      }),
    )
    .required("At least one child section is required"),
});


export default coursevalidationSchema